import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
var ContentConfig = /** @class */ (function () {
    function ContentConfig() {
        this.onCurrentLangChange = new Subject();
    }
    Object.defineProperty(ContentConfig.prototype, "currentLang", {
        /**
         * The lang currently used
         */
        get: function () {
            return this._currentLang;
        },
        set: function (currentLang) {
            this._currentLang = currentLang;
            this.onCurrentLangChange.next({ lang: currentLang });
        },
        enumerable: true,
        configurable: true
    });
    ContentConfig.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ContentConfig_Factory() { return new ContentConfig(); }, token: ContentConfig, providedIn: "root" });
    return ContentConfig;
}());
export { ContentConfig };
